export default __webpack_public_path__ + "static/media/suitcase.e08ec6f7.svg";